export const getters = {
    getChannels(state) {
        return state.channels;
    },
};

export default getters;
